var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',_vm._b({attrs:{"id":_vm.inputId},model:{value:(_vm.zone),callback:function ($$v) {_vm.zone=$$v},expression:"zone"}},'Select',_vm.$attrs,false),_vm._l((_vm.timezones),function(timezone){return _c('option',{key:timezone.value,domProps:{"value":timezone.value}},[_vm._v("\n    "+_vm._s(timezone.text)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }